import React, { FC, useMemo } from 'react'

import * as SC from './styled'

export type NonCollapsableProps = {
  className?: string
  backgroundColor?: string
}

const NonCollapsable: FC<NonCollapsableProps> = (props) => {
  const { className, children, backgroundColor } = props

  const renderContent = useMemo(() => {
    return (
      children &&
      React.Children.map(children, (child, index) => (
        <SC.Wrapper key={`noncollapsable-${index}`}>{child}</SC.Wrapper>
      ))
    )
  }, [children])

  return (
    <SC.Container
      className={`NonCollapsable ${className}`}
      backgroundColor={backgroundColor}
    >
      {renderContent}
    </SC.Container>
  )
}

export default NonCollapsable
